import { useState } from "react";

const STORAGE_KEY = "investorQuestionnaire_answers";

export type QuestionnaireAnswers = Record<string, string | string[]>;

export function useQuestionnaireAnswers() {
    const [answers, setAnswers] = useState<QuestionnaireAnswers>(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            return stored ? (JSON.parse(stored) as QuestionnaireAnswers) : {};
        } catch {
            return {};
        }
    });

    const persist = (next: QuestionnaireAnswers) => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        setAnswers(next);
    };

    const setAnswer = (questionId: string, value: string | string[]) => {
        persist({ ...answers, [questionId]: value });
    };

    const clearAnswers = (questionIds: string[]) => {
        const next = { ...answers };
        questionIds.forEach((id) => delete next[id]);
        persist(next);
    };

    const clearAll = () => {
        localStorage.removeItem(STORAGE_KEY);
        setAnswers({});
    };

    return { answers, setAnswer, clearAnswers, clearAll };
}
